import { JSX } from 'react';
import { tv } from 'tailwind-variants';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';

export type FormInfoProps = {
  title?: string;
  subTitle?: string;
  description?: string;
};

const FormInfo = ({ title, subTitle, description }: FormInfoProps): JSX.Element | null => {
  if (!title && !description) return null;

  const {
    formInfoWrapper,
    formInfoHeader,
    formInfoTitle,
    divider,
    formInfoSubTitle,
    formInfoDescription,
  } = TAILWIND_VARIANTS();
  return (
    <div className={formInfoWrapper()}>
      <div className={formInfoHeader()}>
        <PlainTextWrapper field={{ value: title }} tag="h2" className={formInfoTitle()} />
        <div className={divider()}></div>
      </div>
      <PlainTextWrapper field={{ value: subTitle }} tag="h3" className={formInfoSubTitle()} />
      <RichTextWrapper
        field={{
          value: description,
        }}
        className={formInfoDescription()}
      />
    </div>
  );
};

export default FormInfo;
const TAILWIND_VARIANTS = tv({
  slots: {
    formInfoWrapper: ['w-full', 'flex flex-col gap-component-section-container-gutter'],
    formInfoHeader: ['w-full', 'flex flex-col gap-space-between-base'],
    formInfoTitle: [
      'font-typography-font-family-header',
      'text-component-section-title',
      'text-typography-font-size-large',
      'font-normal',
      'leading-typography-line-height-large',
    ],
    divider: [
      'bg-component-section-divider',
      'h-component-section-divider-height',
      'w-component-section-divider-width',
    ],
    formInfoSubTitle: [
      'font-typography-font-family-body',
      'text-Text-text-default',
      'text-typography-font-size-h5',
      'font-semibold',
      'leading-typography-line-height-h5',
    ],
    formInfoDescription: [
      '[&>*]:!font-typography-font-family-body',
      '[&>*]:!text-p-color-text',
      '[&>*]:!text-typography-font-size-body-medium',
      '[&>*]:!leading-typography-line-height-body-medium',
    ],
  },
});
